var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 8.88886H0.888889C0.402963 8.88886 0 8.4859 0 7.99997C0 7.51405 0.402963 7.11108 0.888889 7.11108H15.1111C15.597 7.11108 16 7.51405 16 7.99997C16 8.4859 15.597 8.88886 15.1111 8.88886Z",
    fill: "#D052FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 16C7.51405 16 7.11108 15.597 7.11108 15.1111V0.888889C7.11108 0.402963 7.51405 0 7.99997 0C8.4859 0 8.88886 0.402963 8.88886 0.888889V15.1111C8.88886 15.597 8.4859 16 7.99997 16Z",
    fill: "#D052FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPurple);
export default __webpack_public_path__ + "static/media/plus-purple.808bd59c8dbac98ad4f7009556bba1c1.svg";
export { ForwardRef as ReactComponent };